import React, { FC, ReactNode } from 'react'

import Layout, { LayoutProps } from '../../layouts/Layout'
import { ActionButtonProps } from '../../components/ActionButton'

import * as SC from './styled'

export type AppointementTemplateProps = {
  className?: string
  layoutProps?: LayoutProps
  title: string
  forms: ReactNode
  newAppointmeentButton?: ActionButtonProps
}

const AppointementTemplate: FC<AppointementTemplateProps> = ({
  layoutProps,
  title,
  forms,
  newAppointmeentButton,
}) => {
  return (
    <Layout {...layoutProps}>
      <SC.Content>
        <SC.Box>
          <SC.Title>{title}</SC.Title>
          <SC.Forms>{forms}</SC.Forms>
          {newAppointmeentButton && <SC.NewAppointementButton {...newAppointmeentButton} />}
        </SC.Box>
      </SC.Content>
    </Layout>
  )
}

export default AppointementTemplate
